var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8799 1.01025L14.7798 7.07113L20.8799 13.132C20.9902 12.9015 21.0571 12.6467 21.0571 12.3746V1.76763C21.0571 1.4955 20.9902 1.24074 20.8799 1.01025Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2898 0H2.71148C2.43935 0 2.18459 0.0669027 1.9541 0.177176L9.75075 7.93454C10.4401 8.62392 11.5612 8.62392 12.2505 7.93454L20.0472 0.177176C19.8167 0.0669027 19.5619 0 19.2898 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12102 1.01025C1.01075 1.24074 0.943848 1.4955 0.943848 1.76763V12.3746C0.943848 12.6468 1.01075 12.9016 1.12102 13.132L7.22118 7.07113L1.12102 1.01025Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.947 7.9043L13.0838 8.76751C11.9352 9.91617 10.0661 9.91617 8.91743 8.76751L8.05426 7.9043L1.9541 13.9652C2.18459 14.0754 2.43935 14.1423 2.71148 14.1423H19.2898C19.5619 14.1423 19.8167 14.0754 20.0472 13.9652L13.947 7.9043Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e1a080faf422deb38a2ecef9bd593f87.svg";
export { ForwardRef as ReactComponent };